import { render, staticRenderFns } from "./BaseValueDisplay.vue?vue&type=template&id=29b909be&"
import script from "./BaseValueDisplay.vue?vue&type=script&lang=ts&"
export * from "./BaseValueDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./BaseValueDisplay.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
